export enum Currency {
  BYN = 'BYN',
  USD = 'USD',
  EUR = 'EUR',
  PLN = 'PLN',
  GBP = 'GBP',
  UAH = 'UAH',
  GEL = 'GEL',
  UZS = 'UZS',
  MXN = 'MXN',
  KZT = 'KZT',
  AZN = 'AZN',
}
